import { client } from '@/common-utils/libraries/axios/axios';
import { buildUrl, replaceParameters } from '@/common-utils/functions/restUtils';

const mutationExportTable = (onSuccess, onError) => {
    return {
        mutationFn: ({ exportApi, uuid, pathParams, origin }) => {
            return client.post(
                buildUrl(replaceParameters(exportApi.url, { uuid }), origin ? { origin } : {}),
                { pathParams }
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationExportTable;